import {
  ServerResult
} from './../../../data/server-result';
import {
  Component,
  OnInit,
  Renderer2
} from '@angular/core';
import {
  NavController,
  AlertController,
  LoadingController,
  ToastController,
  Platform,
  ModalController
} from '@ionic/angular';
import {
  FormBuilder,
  AbstractControl,
  FormGroup
} from '@angular/forms';
// import {RequestMethod, Response} from "@angular/http";
import {
  HttpHeaders
} from '@angular/common/http';
import {
  CommonProvider
} from '../commonServices/common';
import {
  RemoteHttpService
} from 'src/remote-http';
import {
  ContentType,
  RemoteRequest
} from 'src/remote-request';
import * as globals from "src/globals";
import {
  adjustViewZIndex
} from "src/globals";
import {
  MessageDisplayUtil
} from 'src/message-display-utils';
import {
  ConnectionService
} from 'src/providers/connection-service/connection-service';
import {
  Custom_RequestMethod
} from 'src/providers/common-service';
import {
  Router
} from '@angular/router';
import {
  CommonPullupMenuComponent
} from '../modal-screens/common-pullup-menu/common-pullup-menu.component';




@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.page.html',
  styleUrls: ['./forgot-password.page.scss'],
})
export class ForgotPasswordPage implements OnInit {
  public otpExist: boolean;
  public forgotForm: FormGroup;
  public email: AbstractControl;
  public password: AbstractControl;
  public password2: AbstractControl;
  public otp: AbstractControl;


  constructor(
    fb: FormBuilder,
    private nav: NavController,
    private router: Router,
    private renderer: Renderer2,
    private alertCtl: AlertController,
    private loadingCtl: LoadingController,
    private toastCtl: ToastController,
    private platform: Platform,
    private connService: ConnectionService,
    private http: RemoteHttpService,
    private requestMethod: Custom_RequestMethod,
    private modalCtl: ModalController
  ) {

    this.forgotForm = fb.group({
      'email': [''],
      'password': [''],
      'password2': [''],
      'otp': ['']
    });

    this.email = this.forgotForm.controls["email"];
    this.password = this.forgotForm.controls["password"];
    this.password2 = this.forgotForm.controls["password2"];
    this.otp = this.forgotForm.controls["otp"];

  }
  ngOnInit() {}

  ionViewDidEnter() {
    adjustViewZIndex(this.nav, this.renderer);
  }

  async requestOTP() {
    if (this.forgotForm.value.email !== '') {
      let req = new RemoteRequest(globals.ServerUrls.startRestPassword,
        this.requestMethod.post,
        ContentType.URL_ENCODED_FORM_DATA, {
          email: this.forgotForm.value.email
        }
      );
      let busy = await this.loadingCtl.create({
        message: "Requesting OTP..."
      });
      busy.present().then(() => {
        this.http.execute(req).subscribe((resp: any) => {
          busy.dismiss().then(async () => {
            // let result: ServerResult = resp;
            // let result:any = resp;
            if (resp.success) {
              this.showAlertMessage('Password Reset', "OTP for resetting your password is generated and sent to above email.<br>** Re-requesting OTP will invalidate previous OTP request")
              .then(()=>{
                this.otpExist = true;
              });
              // let alert = await this.alertCtl.create({
              //   header: 'Password Reset',
              //   message: "OTP for resetting your password is generated and sent to above email.",
              //   buttons: ['OK']
              // });
              // alert.onDidDismiss().then(() => {
              //   this.otpExist = true;
              // });
              // alert.present();
            }
          });

        }, (error) => {
          busy.dismiss().then(async () => {
            this.showErrorMessage('Password Reset', "Error generating OTP for resetting password");
            // let msg = MessageDisplayUtil.getError(error, this.platform, this.connService,
            //   'Error generating OTP for resetting password.');
            // let alert = await this.alertCtl.create({
            //   header: 'Password Reset',
            //   message: "error",
            //   buttons: ['OK']
            // });

            // alert.present();
          });

        })
      });
    } else {
      this.showErrorMessage('Invalid details', "Please enter your valid email used for signing in.");
      // let alert = await this.alertCtl.create({
      //   header: 'Invalid details',
      //   message: "Please enter your valid email used for signing in.",
      //   buttons: ['OK']
      // });
      // alert.present();
    }
  }


  async changePassword() {
    if (this.forgotForm.value.email !== '' &&
      this.forgotForm.value.password !== '' &&
      this.forgotForm.value.otp) {
      if (this.forgotForm.value.password !== this.forgotForm.value.password2) {

        this.showErrorMessage('Password Mismatch', "Passwords you entered do not match.")
        // let alert = await this.alertCtl.create({
        //   header: 'Password Mismatch',
        //   message: 'Passwords you entered do not match.',
        //   buttons: ['OK']
        // });
        // alert.present();
        return;
      }
      let req = new RemoteRequest(globals.ServerUrls.resetPassword,
        this.requestMethod.post,
        ContentType.URL_ENCODED_FORM_DATA, {
          email: this.forgotForm.value.email,
          password: this.forgotForm.value.password,
          otp: this.forgotForm.value.otp
        }
      );
      let busy = await this.loadingCtl.create({
        message: "Changing password..."
      });
      this.http.execute(req).subscribe((resp: any) => {
        console.debug("changing password : ", resp)
        busy.dismiss().then(async () => {
          if(resp.success)
          this.showAlertMessage('Reset Password', "Successfully changed your password. Login with new credentials.")
          .then(()=>{
            this.router.navigate(['sign-in']);
          });
          // let result: ServerResult = resp;
          // if (resp.success) {
          //   let alert = await this.alertCtl.create({
          //     header: 'Reset Password',
          //     message: 'Successfully changed your password. Login with new credentials.',
          //     buttons: ['OK']
          //   });
          //   alert.onDidDismiss().then(() => {


          //     this.router.navigate(['sign-in']);
          //   });
          //   alert.present();
          // }
        });

      }, (error) => {
        console.debug("error changing password", error)
        busy.dismiss().then(async () => {
          let _error = error?.error
          let _msg = "Error occured while changing password";
          if(_error?.errorMessage) _msg = _error.errorMessage;
          this.showErrorMessage('Reset Password', _msg);
          // let msg = MessageDisplayUtil.getError(error, this.platform, this.connService, 'Error occured while changing password');
          // let alert = await this.alertCtl.create({
          //   header: 'Reset Password Error',
          //   message: msg,
          //   buttons: ['OK']
          // });
          // alert.present();
        })
      })
    } else {
      this.showErrorMessage('Change Password', "You have to enter valid Email, OTP and password for resetting password");
      // let alert = await this.alertCtl.create({
      //   message: "You have to enter valid email, password and OTP for resetting password.",
      // });
      // await alert.present();
    }
  }

  backRouting() {
    this.router.navigate(['sign-in']);
  }

  async showAlertMessage(title: string, content: string) {

    let _message = {
      title: title,
      content: content,
    }

    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        mode: 'infoDisplay',
        message: _message,
      }
    })
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      if (document.getElementsByClassName('inner-content')[0])
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then(async (data: any) => {});
  }

  async showErrorMessage(title: string, content: string) {

    let _message = {
      title: title,
      content: content,
    }

    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        mode: 'infoDisplay',
        message: _message,
        mainBtnColor: 'danger',
      }
    })
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      if (document.getElementsByClassName('inner-content')[0])
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then(async (data: any) => {});
  }


}
